<script>
  import AXHR from "../components/js/axhr.js";
  import { fade } from "svelte/transition";
  import Alert from "../components/Alert.svelte";
  import Title from "../components/Title.svelte";
  import Navigationbar from "../components/Navigationbar.svelte";

  import { session } from "../components/js/store.js";
  let sessions;
  $: sessions;
  session.subscribe((value) => {
    sessions = value;
  });

  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  //navigation
  let navigation = [];
  $: if (sessions.loggedin == true) {
    if (sessions.user.firstName != undefined) {
      navigation["message"] =
        sessions.user.firstName + " " + sessions.user.lastName;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  //alert
  let alert = [];

  //TABLE SECTION
  import Modal from "../components/Modal.svelte";
  import format from "number-format.js";
  $: dataFiltered = [];
  function loadData(endpoint, token, filter = false) {
    var config = {
      method: "get",
      url: endpoint,
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    AXHR(config)
      .then(function (response) {
        let res;
        res = response.data;
        if (filter !== false) {
          res = res.filter((el) => {
            return el[filter.name] !== filter.value;
          });
        } else {
          res = res;
        }
        dataFiltered = res;
      })
      .catch(function (error) {
        alert = [
          ...alert,
          {
            title: "Oops...",
            message: error.response.data.message,
            color: "yellow",
          },
        ];
      });
  }
  if (sessions) {
    loadData(
      sessions.api +
        "/rb/" +
        sessions.routeractive.id +
        "/ip-hotspot-user-profile",
      sessions.token,
      { name: "default", value: true }
    );
  }

  function fillEdit(v) {
    document.getElementById("quickAddHotspotUser").reset();
    if (
      document.getElementById("formAddHotspotUser").classList.remove("hidden")
    ) {
      document.getElementById("formAddHotspotUser").classList.add("block");
    }
    document.getElementById("formAddHotspotUser").classList.add("shake");
    let val_addrpool = "none";
    if (v.addressPool === undefined) {
      val_addrpool = "none";
    } else {
      val_addrpool = v.addressPool;
    }
    let val_addMacCookie = "N";
    if (v.addMacCookie === true) {
      val_addMacCookie = "Y";
    } else {
      val_addMacCookie = "N";
    }
    if (v.parentQueue == undefined) {
      v.parentQueue = "";
    }

    if (v.onLogin) {
      payload = {
        id: v.id,
        addrpool: val_addrpool,
        name: v.name,
        sharedusers: v.sharedUsers,
        ratelimit: v.rateLimit,
        expmode: splitStrings(v.onLogin, 1, true),
        validity: splitStrings(v.onLogin, 3),
        getprice: splitStrings(v.onLogin, 2),
        getsprice: splitStrings(v.onLogin, 4),
        getlock: val_addMacCookie,
        parent: v.parentQueue,
      };
    } else {
      payload = {
        id: v.id,
        addrpool: val_addrpool,
        name: v.name,
        sharedusers: v.sharedUsers,
        ratelimit: v.rateLimit,
        expmode: "0",
        validity: "",
        getprice: "",
        getsprice: "",
        getlock: val_addMacCookie,
        parent: v.parentQueue,
      };
    }
    console.log(payload);
    setTimeout(() => {
      document.getElementById("formAddHotspotUser").classList.remove("shake");
    }, 2500);
  }

  let selection = [];
  let selectionUser = [];
  let deleteSelected = false;

  $: console.log(selectionUser);
  $: if (selection.length > 0) {
    document.getElementById("selectAll").indeterminate = true;
    if (selection.length === dataFiltered.length) {
      setTimeout(() => {
        document.getElementById("selectAll").indeterminate = false;
      }, 100);
      document.getElementById("selectAll").checked = true;
    }
    deleteSelected = true;
  } else if (selection.length === 0) {
    setTimeout(() => {
      if (document.getElementById("selectAll")) {
        document.getElementById("selectAll").indeterminate = false;
      }
    }, 100);
    deleteSelected = false;
  }
  function SelectAll(state, css) {
    for (var i = 0; i < dataFiltered.length; i++) {
      if (document.getElementsByClassName(css)[i]) {
        document.getElementsByClassName(css)[i].checked = state;
        if (state == true) {
          const dataRemoved = selection.filter((el) => {
            return el !== document.getElementsByClassName(css)[i].value;
          });
          selection = dataRemoved;
          selection = [
            ...selection,
            document.getElementsByClassName(css)[i].value,
          ];

          const dataRemovedUser = selectionUser.filter((el) => {
            return (
              el !==
              document.getElementsByClassName(css)[i].getAttribute("data-user")
            );
          });
          selectionUser = dataRemovedUser;
          selectionUser = [
            ...selectionUser,
            document.getElementsByClassName(css)[i].getAttribute("data-user"),
          ];
        } else {
          const dataRemoved = selection.filter((el) => {
            return el !== document.getElementsByClassName(css)[i].value;
          });
          selection = dataRemoved;

          const dataRemovedUser = selectionUser.filter((el) => {
            return (
              el !==
              document.getElementsByClassName(css)[i].getAttribute("data-user")
            );
          });
          selectionUser = dataRemovedUser;
        }
      }
    }
  }

  function SelectData(e) {
    if (e.target.checked == true) {
      console.log("kclas");
      const dataRemoved = selection.filter((el) => {
        return el !== e.target.value;
      });
      selection = dataRemoved;
      selection = [...selection, e.target.value];

      const dataRemovedUser = selectionUser.filter((el) => {
        return el !== e.target.dataset.user;
      });
      selectionUser = dataRemovedUser;
      selectionUser = [...selectionUser, e.target.dataset.user];
    } else {
      const dataRemoved = selection.filter((el) => {
        return el !== e.target.value;
      });
      selection = dataRemoved;

      const dataRemovedUser = selectionUser.filter((el) => {
        return el !== e.target.dataset.user;
      });
      selectionUser = dataRemovedUser;
    }
  }
  function deleteSelectedUser(selection) {
    loading = true;
    let data = {
      selection: selection,
    };

    var config = {
      method: "delete",
      url:
        sessions.api +
        "/rb/" +
        sessions.routeractive.id +
        "/hotspot/profile/mass",
      headers: {
        Authorization: "Bearer " + sessions.token,
        "Content-Type": "application/json",
      },
      data: data,
    };

    AXHR(config)
      .then(function (response) {
        setTimeout(() => {
          document.getElementById("selectAll").indeterminate = false;
        }, 100);
        document.getElementById("selectAll").checked = false;
        SelectAll(false, "idUser");
        if (response.data.length != undefined) {
          alert = [
            ...alert,
            {
              title: "Mikhub",
              message: response.data.length + " Profile Berhasil dihapus",
              color: "green",
            },
          ];
        } else {
          alert = [
            ...alert,
            {
              title: "Mikhub",
              message: "Profile " + response.data.name + " Berhasil dihapus",
              color: "green",
            },
          ];
        }
        loading = false;
        loadData(
          sessions.api +
            "/rb/" +
            sessions.routeractive.id +
            "/ip-hotspot-user-profile",
          sessions.token,
          { name: "default", value: true }
        );
      })
      .catch(function (error) {
        loading = false;
        alert = [
          ...alert,
          {
            title: "Oops...",
            message: error.response.data.message,
            color: "yellow",
          },
        ];
      });
  }

  function splitStrings(strings, get, pure = false) {
    strings = strings.split(",");
    if (get == 1) {
      if (pure == true) {
        strings = strings[1];
      } else {
        if (strings[1] == "rem") {
          strings = "Remove";
        } else if (strings[1] == "ntf") {
          strings = "Notice";
        } else if (strings[1] == "remc") {
          strings = "Remove & Record";
        } else if (strings[1] == "ntfc") {
          strings = "Notice & Record";
        } else {
          strings = "";
        }
      }
    } else if (get == 2) {
      strings = strings[2];
    } else if (get == 3) {
      strings = strings[3];
    } else if (get == 4) {
      strings = strings[4];
    } else if (get == 5) {
      strings = strings[5];
    }
    return strings;
  }

  //FORM SECTION

  $: parentFiltered = [];
  function loadparentData(endpoint, token, filter = false) {
    var config = {
      method: "get",
      url: endpoint,
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    AXHR(config).then(function (response) {
      let res;
      res = response.data;
      if (filter !== false) {
        res = res.filter((el) => {
          return el[filter.name] !== filter.value;
        });
      } else {
        res = res;
      }
      parentFiltered = res;
    });
  }
  $: addrpoolFiltered = [];
  function loadaddrpoolData(endpoint, token, filter = false) {
    var config = {
      method: "get",
      url: endpoint,
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    AXHR(config).then(function (response) {
      let res;
      res = response.data;
      if (filter !== false) {
        res = res.filter((el) => {
          return el[filter.name] !== filter.value;
        });
      } else {
        res = res;
      }
      addrpoolFiltered = res;
    });
  }
  if (sessions) {
    loadparentData(
      sessions.api + "/rb/" + sessions.routeractive.id + "/queue-simple",
      sessions.token,
      { name: "dynamic", value: true }
    );
    loadaddrpoolData(
      sessions.api + "/rb/" + sessions.routeractive.id + "/ip-pool",
      sessions.token,
      false
    );
  }
  let loading = false;

  let payload;
  $: payload = {
    id: false,
    addrpool: "none",
    name: "",
    sharedusers: "",
    ratelimit: "",
    expmode: "0",
    validity: "",
    getprice: "",
    getsprice: "",
    getlock: "N",
    parent: "",
  };

  let require;

  $: require = {
    addrpool: payload.addrpool,
    name: payload.name,
    sharedusers: payload.sharedusers,
    ratelimit: payload.ratelimit,
  };
  $: if (payload.expmode && payload.expmode !== "0") {
    require = {
      addrpool: payload.addrpool,
      name: payload.name,
      sharedusers: payload.sharedusers,
      ratelimit: payload.ratelimit,
      validity: payload.validity,
    };
  } else {
    require = {
      addrpool: payload.addrpool,
      name: payload.name,
      sharedusers: payload.sharedusers,
      ratelimit: payload.ratelimit,
    };
  }
  let number;
  $: number = {
    getprice: payload.getprice,
    getsprice: payload.getsprice,
  };

  let email;
  $: email = {};
  let errorForm = [];
  function validator() {
    errorForm = [];
    for (var k in require) {
      if (document.getElementById(k + "-labelwarning")) {
        document.getElementById(k + "-labelwarning").style = "";
      }
      if (document.getElementById(k + "-warning")) {
        document.getElementById(k + "-warning").style.display = "none";
        document.getElementById(k + "-warning").innerHTML = "";
      }
      if (
        require[k] !== undefined &&
        require[k] !== null &&
        require[k] !== "" &&
        require[k] !== false
      ) {
      } else {
        errorForm = [...errorForm, { field: k, message: "Mohon diisi" }];
        if (document.getElementById(k + "-warning")) {
          document.getElementById(k + "-warning").style.display =
            "inline-block";
          document.getElementById(k + "-warning").innerHTML = "Mohon diisi";
        }
        if (document.getElementById(k + "-labelwarning")) {
          document.getElementById(k + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }
    for (var n in number) {
      if (document.getElementById(n + "-warning")) {
        document.getElementById(n + "-warning").style.display = "none";
        document.getElementById(n + "-labelwarning").style = "";
        document.getElementById(n + "-warning").innerHTML = "";
      }
      if (/^\+?(0|[1-9]\d*)$/.test(number[n])) {
      } else {
        if (require[n] != undefined || number[n] != "") {
          errorForm = [
            ...errorForm,
            { field: n, message: "Pastikan Hanya Angka" },
          ];
        }
        if (number[n] !== "") {
          if (document.getElementById(n + "-warning")) {
            document.getElementById(n + "-warning").style.display =
              "inline-block";
            document.getElementById(n + "-warning").innerHTML =
              "Pastikan Hanya Angka";
          }
          if (document.getElementById(n + "-labelwarning")) {
            document.getElementById(n + "-labelwarning").style.color =
              "rgb(255, 102, 102)";
          }
        }
      }
    }
    for (var e in email) {
      if (document.getElementById(e + "-warning")) {
        document.getElementById(e + "-warning").style.display = "none";
        document.getElementById(e + "-labelwarning").style = "";
        document.getElementById(e + "-warning").innerHTML = "";
      }
      if (
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          email[e]
        )
      ) {
      } else {
        if (require[e] != undefined || email[e] !== "") {
          errorForm = [
            ...errorForm,
            { field: e, message: "Pastikan Email sudah tepat" },
          ];
        }
        if (email[e] !== "") {
          if (document.getElementById(e + "-warning")) {
            document.getElementById(e + "-warning").style.display =
              "inline-block";
            document.getElementById(e + "-warning").innerHTML =
              "Pastikan Email sudah tepat";
          }
          if (document.getElementById(e + "-labelwarning")) {
            document.getElementById(e + "-labelwarning").style.color =
              "rgb(255, 102, 102)";
          }
        }
      }
    }

    if (errorForm.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  $: state = { title: "Quick Add", subtitle: "Create Hotspot Profile" };
  $: if (payload.id) {
    state = { title: "Quick Edit", subtitle: "Edit Hotspot Profile" };
  } else {
    state = { title: "Quick Add", subtitle: "Create Hotspot Profile" };
  }

  let success;
  $: success = false;
  async function handleSubmit() {
    let data;
    let method = "post";
    if (payload.id) {
      method = "put";

      data = {
        id: payload.id,
        addrpool: payload.addrpool,
        name: payload.name,
        sharedusers: payload.sharedusers,
        ratelimit: payload.ratelimit,
        expmode: payload.expmode,
        validity: payload.validity,
        getprice: payload.getprice,
        getsprice: payload.getsprice,
        getlock: payload.getlock,
        parent: payload.parent,
      };
    } else {
      method = "post";
      data = {
        addrpool: payload.addrpool,
        name: payload.name,
        sharedusers: payload.sharedusers,
        ratelimit: payload.ratelimit,
        expmode: payload.expmode,
        validity: payload.validity,
        getprice: payload.getprice,
        getsprice: payload.getsprice,
        getlock: payload.getlock,
        parent: payload.parent,
      };
    }
    loading = true;
    let valid;
    valid = validator();
    if (valid) {
      var config = {
        method: method,
        url:
          sessions.api + "/rb/" + sessions.routeractive.id + "/hotspot/profile",
        headers: {
          Authorization: "Bearer " + sessions.token,
          "Content-Type": "application/json",
        },
        data: data,
      };

      AXHR(config)
        .then(function (response) {
          alert = [
            ...alert,
            {
              title: "Mikhub",
              message: "Perintah berhasil dieksekusi",
              color: "green",
            },
          ];
          success = true;
          loading = false;

          loadData(
            sessions.api +
              "/rb/" +
              sessions.routeractive.id +
              "/ip-hotspot-user-profile",
            sessions.token,
            { name: "default", value: true }
          );
          setTimeout(() => {
            success = false;
            payload = {
              id: false,
              addrpool: "none",
              name: "",
              sharedusers: "",
              ratelimit: "",
              expmode: "0",
              validity: "",
              getprice: "",
              getsprice: "",
              getlock: "N",
              parent: "",
            };
          }, 500);
        })
        .catch(function (error) {
          success = false;
          loading = false;

          document.getElementById("formAddHotspotUser").classList.add("shake");
          setTimeout(() => {
            document
              .getElementById("formAddHotspotUser")
              .classList.remove("shake");
          }, 2500);
          alert = [
            ...alert,
            {
              title: "Oops...",
              message: error.response.data.message,
              color: "yellow",
            },
          ];
        });
    } else {
      success = false;
      loading = false;
      document.getElementById("formAddHotspotUser").classList.add("shake");
      setTimeout(() => {
        document.getElementById("formAddHotspotUser").classList.remove("shake");
      }, 2500);
    }
  }
  let loadTable = false;
  setTimeout(() => {
    loadTable = true;
  }, 1000);
  import MakeSortable from "../components/MakeTable/MakeSortable.svelte";
  import SortHeader from "../components/MakeTable/SortHeader.svelte";
  let filter = "",
    imgsortIconCss =
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="inline w-3 h-3"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" /></svg>',
    imgsortIconAscCss =
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="inline w-3 h-3"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"></path></svg>',
    imgsortIconDescCss =
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="inline w-3 h-3"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4" /></svg>';
</script>

<svelte:head>
  <title>Mikhub - Hotspot Profiles</title>
</svelte:head>
<Navigationbar backbtn="false" message={navigation["message"]} align="center" />
<main
  transition:fade
  class="max-w-screen-xl px-2 pt-24 mx-auto mb-20 lg:pt-24 md:pt-20"
>
  <Title
    title="Hotspot Profile"
    subtitle="Manage Your Hotspot Profile"
    tipe="3"
    href="./"
  />
  <div class="mx-auto my-2 lg:my-2">
    <div class="relative block w-full gap-8 lg:flex md:block">
      <!--FORM SECTION-->
      <div
        class="fixed bottom-0 right-0 z-10 block w-10 mb-20 mr-5 lg:z-auto md:z-auto lg:hidden md:block lg:right-0 lg:bottom-0 lg:mt-0 lg:mr-5"
      >
        <a
          href="./hotspot-user-add"
          on:click|preventDefault={() => {
            document
              .getElementById("formAddHotspotUser")
              .classList.remove("hidden");
            document
              .getElementById("formAddHotspotUser")
              .classList.add("block");
            payload = {
              id: false,
              addrpool: "none",
              name: "",
              sharedusers: "",
              ratelimit: "",
              expmode: "0",
              validity: "",
              getprice: "",
              getsprice: "",
              getlock: "N",
              parent: "",
            };
          }}
          class="flex items-center justify-center w-10 h-10 text-xl text-center text-white bg-blue-600 rounded-full shadow-md lg:w-auto md:w-auto active:bg-gray-500 focus:outline-none hover:bg-blue-400"
          >+</a
        >
      </div>
      <div
        id="formAddHotspotUser"
        class="fixed top-0 left-0 right-0 z-50 hidden w-full h-screen p-5 py-0 my-0 overflow-y-auto bg-white rounded-none shadow-lg lg:overflow-y-none md:overflow-y-auto lg:h-full md:h-screen lg:block lg:py-5 md:py-5 lg:z-auto md:z-50 lg:my-5 md:my-0 lg:rounded-lg md:rounded-lg lg:w-3/12 md:w-full lg:sticky md:fixed"
      >
        <div
          class="h-auto pt-0 pb-20 md:pt-0 lg:pb-0 md:pb-b lg:h-auto md:h-auto lg:pt-0"
        >
          <div class="sticky top-0 z-10 lg:z-0 md:z-10 lg:block md:block">
            <Title title={state.title} subtitle={state.subtitle} tipe="1" />
          </div>

          {#if success}
            <div class="w-full" on:click={() => (success = false)}>
              <div
                class="w-full p-2 mx-auto mb-2 text-xs bg-gray-300 border-4 border-t border-b border-r border-gray-600 border-solid rounded shadow-lg color-white"
              >
                <h2
                  class="relative flex items-center justify-between text-sm font-bold"
                >
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      class="inline-block w-4 h-4"
                    >
                      <path
                        d="M4 8a6 6 0 0 1 4.03-5.67 2 2 0 1 1 3.95 0A6 6 0 0 1 16 8v6l3
              2v1H1v-1l3-2V8zm8 10a2 2 0 1 1-4 0h4z"
                      />
                    </svg>
                    Berhasil
                  </span>
                  <span
                    class="absolute top-0 right-0 -mt-2 text-sm font-bold text-gray-700"
                    on:click={() => (success = false)}>x</span
                  >
                </h2>
                <p>
                  Kamu berhasil {#if payload.id != false}
                    Menggubah
                  {:else}
                    Menambah
                  {/if} profil di server {sessions.routeractive.name}
                </p>
              </div>
            </div>
          {/if}

          <form
            class="px-2 pt-2"
            autocomplete="off"
            on:submit|preventDefault={handleSubmit}
            id="quickAddHotspotUser"
          >
            <section class="mt-5">
              <label for="addrpool" class="relative block text-sm font-light">
                <select
                  class="w-full rounded-lg form-input"
                  name="addrpool"
                  id="addrpool"
                  autocomplete="off"
                  type="text"
                  placeholder="IP Pool"
                  bind:value={payload.addrpool}
                >
                  <option value="none">none</option>
                  {#each addrpoolFiltered as p}
                    <option value={p.name}>{p.name}</option>
                  {/each}
                </select>
                <span
                  class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                  id="addrpool-labelwarning"
                  >IP Pool
                </span>
                <span
                  class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                  id="addrpool-warning"
                />
              </label>
            </section>
            <section class="mt-5">
              <label for="name" class="relative block text-sm font-light">
                <input
                  class="w-full rounded-lg form-input"
                  name="name"
                  id="name"
                  autocomplete="off"
                  type="text"
                  placeholder="Profile Name"
                  bind:value={payload.name}
                />
                <span
                  class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                  id="name-labelwarning"
                  >Profile Name
                </span>
                <span
                  class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                  id="name-warning"
                />
              </label>
            </section>

            <section class="mt-5">
              <label
                for="sharedusers"
                class="relative block text-sm font-light"
              >
                <input
                  class="w-full rounded-lg form-input"
                  name="sharedusers"
                  id="sharedusers"
                  autocomplete="off"
                  type="text"
                  placeholder="Shared User"
                  bind:value={payload.sharedusers}
                />
                <span
                  class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                  id="sharedusers-labelwarning"
                  >Shared User
                </span>
                <span
                  class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                  id="sharedusers-warning"
                />
              </label>
            </section>

            <section class="mt-5">
              <label for="ratelimit" class="relative block text-sm font-light">
                <input
                  class="w-full rounded-lg form-input"
                  name="ratelimit"
                  id="ratelimit"
                  autocomplete="off"
                  type="text"
                  placeholder="Rate Limit"
                  bind:value={payload.ratelimit}
                />
                <span
                  class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                  id="ratelimit-labelwarning"
                  >Rate Limit
                </span>
                <span
                  class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                  id="ratelimit-warning"
                />
              </label>
            </section>

            <section class="mt-5">
              <label for="expmode" class="relative block text-sm font-light">
                <select
                  class="w-full rounded-lg form-input"
                  name="expmode"
                  id="expmode"
                  autocomplete="off"
                  type="text"
                  placeholder="Expired Mode"
                  bind:value={payload.expmode}
                >
                  <option value="0">No Expired</option>
                  <option value="rem">Remove</option>
                  <option value="ntf">Notice</option>
                  <option value="remc">Remove Record</option>
                  <option value="ntfc">Notice Record</option>
                </select>
                <span
                  class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                  id="expmode-labelwarning"
                  >Expired Mode
                </span>
                <span
                  class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                  id="expmode-warning"
                />
              </label>
            </section>

            <section class="mt-5">
              <label for="validity" class="relative block text-sm font-light">
                <input
                  class="w-full rounded-lg form-input"
                  name="validity"
                  id="validity"
                  autocomplete="off"
                  type="text"
                  placeholder="Validity"
                  bind:value={payload.validity}
                />
                <span
                  class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                  id="validity-labelwarning"
                  >Validity
                </span>
                <span
                  class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                  id="validity-warning"
                />
                <p class="text-xs text-right text-gray-500">
                  ex: 30d = 30hari, 12h = 12jam, 4w3d = 31hari
                </p>
              </label>
            </section>
            <section class="mt-5">
              <label for="getprice" class="relative block text-sm font-light">
                <input
                  class="w-full rounded-lg form-input"
                  name=""
                  id="getprice"
                  autocomplete="off"
                  type="text"
                  placeholder="Price"
                  bind:value={payload.getprice}
                />
                <span
                  class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                  id="getprice-labelwarning"
                  >Price
                </span>
                <span
                  class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                  id="getprice-warning"
                />
              </label>
            </section>
            <section class="mt-5">
              <label for="getsprice" class="relative block text-sm font-light">
                <input
                  class="w-full rounded-lg form-input"
                  name=""
                  id="getsprice"
                  autocomplete="off"
                  type="text"
                  placeholder="Selling Price"
                  bind:value={payload.getsprice}
                />
                <span
                  class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                  id="getsprice-labelwarning"
                  >Selling Price
                </span>
                <span
                  class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                  id="getsprice-warning"
                />
              </label>
            </section>
            <section class="mt-5">
              <label for="parent" class="relative block text-sm font-light">
                <select
                  class="w-full rounded-lg form-input"
                  name="parent"
                  id="parent"
                  autocomplete="off"
                  type="text"
                  placeholder="Parent"
                  bind:value={payload.parent}
                >
                  <option value="">None</option>
                  {#each parentFiltered as p}
                    <option value={p.name}>{p.name}</option>
                  {/each}
                </select>
                <span
                  class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                  id="parent-labelwarning"
                  >Parent
                </span>
                <span
                  class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                  id="parent-warning"
                />
              </label>
            </section>

            <section class="mt-5">
              <label for="getlock" class="relative block text-sm font-light">
                <select
                  class="w-full rounded-lg form-input"
                  name="getlock"
                  id="getlock"
                  bind:value={payload.getlock}
                >
                  <option value="N">Disable</option>
                  <option value="Y">Enable</option>
                </select>
                <span
                  class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                  id="getlock-labelwarning"
                  >User Lock
                </span>
                <span
                  class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                  id="getlock-warning"
                />
              </label>
            </section>

            <div
              class="flex justify-between w-full gap-2 lg:justify-between md:justify-start"
            >
              {#if loading}
                <button
                  type="submit"
                  class="w-auto px-5 py-1 mt-5 text-gray-100 bg-gray-500 rounded-lg opacity-25 text-1xl active:bg-gray-500 focus:outline-none"
                  disabled="disabled"
                >
                  MEMPROSES...
                </button>
              {:else}
                <button
                  type="submit"
                  class="w-auto px-5 py-1 mt-5 text-gray-100 bg-gray-700 rounded-lg text-1xl active:bg-gray-500 focus:outline-none"
                  on:click={handleSubmit}
                >
                  SAVE
                </button>
              {/if}

              <button
                type="button"
                on:click|preventDefault={() => {
                  document
                    .getElementById("formAddHotspotUser")
                    .classList.remove("block");
                  document
                    .getElementById("formAddHotspotUser")
                    .classList.add("hidden");
                }}
                class="block w-auto px-5 py-1 mt-5 text-gray-100 bg-gray-500 rounded-lg lg:hidden md:block text-1xl active:bg-gray-500 focus:outline-none"
              >
                CANCEL
              </button>
              <button
                type="button"
                on:click|preventDefault={() => {
                  payload = {
                    id: false,
                    addrpool: "none",
                    name: "",
                    sharedusers: "",
                    ratelimit: "",
                    expmode: "0",
                    validity: "",
                    getprice: "",
                    getsprice: "",
                    getlock: "N",
                    parent: "",
                  };
                }}
                class="hidden w-auto px-5 py-1 mt-5 text-gray-100 bg-gray-500 rounded-lg lg:block md:hidden text-1xl active:bg-gray-500 focus:outline-none"
              >
                CANCEL
              </button>
            </div>
          </form>
        </div>
      </div>
      <!--/FORM SECTION-->

      <div
        class="w-full px-2 py-5 pb-2 my-5 bg-white rounded-lg shadow-lg lg:w-9/12 md:w-full"
      >
        <!--TABLE SECTION-->
        {#if loadTable}
          <MakeSortable
            data={dataFiltered}
            let:table
            {filter}
            filterFields={[
              "addressPool",
              "name",
              "parentQueue",
              "rateLimit",
              "sharedUsers",
              "onLogin",
            ]}
            sortIconCss={imgsortIconCss}
            sortIconAscCss={imgsortIconAscCss}
            sortIconDescCss={imgsortIconDescCss}
          >
            <div
              class="flex flex-wrap items-center justify-between w-full pr-2 mb-2"
            >
              <div
                class="flex justify-start w-1/2 gap-2 py-1 lg:w-4/12 md:w-2/6"
              >
                {#if deleteSelected}
                  <Modal backdropClose size="lg:w-2/5 w-full z-50">
                    <div class="mt-0 lg:mt-0 md:mt-4" slot="trigger" let:open>
                      {#if loading}
                        <button
                          on:click|preventDefault
                          class="px-2 py-1 text-xs text-red-100 bg-red-600 bg-opacity-50 rounded-md focus:outline-none hover:bg-red-500"
                          disabled>Memproses...</button
                        >
                      {:else}
                        <button
                          on:click={open}
                          class="px-2 py-1 text-xs text-red-100 bg-red-600 rounded-md focus:outline-none hover:bg-red-500"
                          >Delete Selected <i>({selection.length})</i></button
                        >
                      {/if}
                    </div>

                    <div slot="header">
                      <h1 class="text-lg">Delete This List ...?</h1>
                    </div>
                    <div slot="content" class="h-full">
                      <div class="w-full rounded-lg lg:px-2">
                        <div
                          class="flex gap-2 overflow-y-auto"
                          style="height:60vh"
                        >
                          <div class="w-1/2">
                            <table class="w-full table-fixed">
                              <thead class="w-full">
                                <th
                                  class="w-1/3 px-2 py-1 text-sm text-center bg-white border-b border-r border-gray-300"
                                  >#</th
                                >
                                <th
                                  class="w-2/3 px-2 py-1 text-sm text-center truncate whitespace-pre-wrap bg-white border-b border-r border-gray-300"
                                  >Name</th
                                >
                              </thead>
                              <tbody>
                                {#each selectionUser as s, i}
                                  <tr class="w-full hover:bg-gray-200">
                                    <td
                                      class="w-1/3 px-2 py-1 text-sm text-center text-gray-700 border-b border-r border-gray-300 odd:bg-white even:bg-gray-100"
                                      >{i + 1}</td
                                    >
                                    <td
                                      title={s}
                                      class="w-2/3 px-2 py-1 text-sm text-center text-gray-700 border-b border-r border-gray-300 odd:bg-white even:bg-gray-100"
                                      >{s}</td
                                    >
                                  </tr>
                                {/each}
                              </tbody>
                            </table>
                          </div>
                          <div class="sticky top-0 w-1/2 text-center">
                            <p
                              class="px-2 py-3 mx-2 mb-5 text-sm text-center text-red-800 bg-yellow-200 rounded"
                            >
                              The following is a list of users who will be
                              deleted, please make sure first
                            </p>
                            <button
                              on:click|preventDefault={() =>
                                deleteSelectedUser(selection)}
                              on:click={() =>
                                document
                                  .getElementsByClassName("backdrop")[0]
                                  .click()}
                              class="px-2 py-1 text-sm text-red-100 bg-red-600 rounded-md focus:outline-none hover:bg-red-500"
                              >Delete Now <i>({selection.length})</i></button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </Modal>
                {:else}
                  <div class="mt-0 lg:mt-0 md:mt-4">
                    <button
                      on:click={() =>
                        loadData(
                          sessions.api +
                            "/rb/" +
                            sessions.routeractive.id +
                            "/ip-hotspot-user-profile",
                          sessions.token,
                          { name: "default", value: true }
                        )}
                      class="px-2 py-1 text-xs font-bold text-gray-800 bg-white rounded-md shadow-md hover:bg-gray-100 focus:outline-none"
                      ><svg
                        class="inline w-4 h-4"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                        />
                      </svg> Refresh</button
                    >
                  </div>
                {/if}
              </div>
              <div
                class="flex items-center justify-end w-1/2 gap-4 px-2 py-1 text-xs lg:w-4/12 md:w-2/6"
              >
                <span>Total : <b>{table.rows.length}</b></span><span
                  >Filtered : <b>{table.sortedAndFilteredRows.length}</b></span
                >
              </div>
              <input
                type="text"
                class="w-full gap-2 px-2 py-1 text-sm font-bold bg-white border border-gray-200 rounded-md shadow pointer-events-auto lg:w-4/12 md:w-2/6 focus:outline-none md:focus:border-gray-600"
                placeholder="Search..."
                bind:value={filter}
              />
            </div>

            <div class="w-full">
              <div
                transition:fade
                class="sticky z-10 w-full mb-5 bg-gray-100 border-b-4 border-gray-400 rounded-lg shadow-lg lg:shadow-lg md:shadow-lg lg:top-20 md:top-20 top-16"
              >
                <div
                  class="flex flex-no-wrap items-end justify-start w-full overflow-x-auto text-center cursor-pointer lg:items-center md:items-end"
                >
                  <div class="w-8 p-2 text-sm italic font-bold">
                    <label for="selectAll">
                      <input
                        on:click={(e) => SelectAll(e.target.checked, "idUser")}
                        type="checkbox"
                        id="selectAll"
                        class="mx-1 my-1 text-xl rounded-lg form-checkbox hover:shadow-outline"
                      />
                    </label>
                  </div>
                  <SortHeader
                    css="w-48 p-2 text-sm font-bold italic"
                    path={(row) => String(row.name)}>Profile Name</SortHeader
                  >
                  <SortHeader
                    css="w-16 p-2 text-sm font-bold italic"
                    path={(row) => String(row.sharedUsers)}>Slot</SortHeader
                  >
                  <SortHeader
                    css="w-24 p-2 text-sm font-bold italic"
                    path={(row) =>
                      format("Rp#.##0,00", splitStrings(row.onLogin, 2))}
                    >Price</SortHeader
                  >
                  <SortHeader
                    css="w-24 p-2 text-sm font-bold italic"
                    path={(row) =>
                      format("Rp#.##0,00", splitStrings(row.onLogin, 4))}
                    >Sell Price</SortHeader
                  >
                  <SortHeader
                    css="w-26 p-2 text-sm font-bold italic"
                    path={(row) => String(row.rateLimit)}>Rate Limit</SortHeader
                  >

                  <SortHeader
                    css="w-24 p-2 text-sm font-bold italic"
                    path={(row) => splitStrings(row.onLogin, 3)}
                    >Expired</SortHeader
                  >

                  <SortHeader
                    css="w-40 p-2 text-sm font-bold italic"
                    path={(row) => splitStrings(row.onLogin, 3)}
                    >Mode</SortHeader
                  >
                </div>
              </div>

              <div class="w-full">
                {#if table.pageRows.length > 0}
                  {#each table.pageRows as d}
                    <div
                      class="w-full mx-0 my-2 overflow-hidden rounded-lg shadow-md lg:my-1 md:my-1 hover:bg-gray-100"
                    >
                      <label
                        for="select-{d.name}"
                        class="flex flex-wrap items-center justify-start w-full"
                      >
                        <div class="w-8 p-2 text-sm">
                          {#if selection.some(function (el) {
                            return el == d.id;
                          })}
                            <input
                              on:click={(e) => SelectData(e)}
                              name="id[]"
                              bind:group={selection}
                              id="select-{d.name}"
                              data-user={d.name}
                              type="checkbox"
                              value={d.id}
                              class="my-1 text-xl rounded-lg idUser form-checkbox hover:shadow-outline"
                              selected
                            />
                          {:else}
                            <input
                              on:click={(e) => SelectData(e)}
                              name="id[]"
                              bind:group={selection}
                              id="select-{d.name}"
                              data-user={d.name}
                              type="checkbox"
                              value={d.id}
                              class="my-1 text-xl rounded-lg idUser form-checkbox hover:shadow-outline"
                            />
                          {/if}
                        </div>
                        <div
                          class="w-48 p-2 text-sm"
                          on:click|preventDefault={fillEdit(d)}
                        >
                          <div
                            class="block font-mono text-xs italic lg:hidden md:block"
                          >
                            Profile Name
                          </div>
                          {#if d.name}
                            {String(d.name)}
                          {:else}
                            -
                          {/if}
                        </div>
                        <div class="w-16 p-2 text-sm">
                          <div
                            class="block font-mono text-xs italic lg:hidden md:block"
                          >
                            Slot
                          </div>
                          {#if d.sharedUsers}
                            {String(d.sharedUsers)}
                          {:else}
                            -
                          {/if}
                        </div>
                        <div class="w-24 p-2 text-sm">
                          <div
                            class="block font-mono text-xs italic lg:hidden md:block"
                          >
                            Price
                          </div>
                          {#if d.onLogin}
                            {#if splitStrings(d.onLogin, 2) > 0}
                              {format("#.##0,00", splitStrings(d.onLogin, 2))}
                            {:else}
                              -
                            {/if}
                          {:else}
                            -
                          {/if}
                        </div>
                        <div class="w-24 p-2 text-sm">
                          <div
                            class="block font-mono text-xs italic lg:hidden md:block"
                          >
                            Sale Price
                          </div>
                          {#if d.onLogin}
                            {#if splitStrings(d.onLogin, 4) > 0}
                              {format("#.##0,00", splitStrings(d.onLogin, 4))}
                            {:else}
                              -
                            {/if}
                          {:else}
                            -
                          {/if}
                        </div>
                        <div class="p-2 text-sm w-28">
                          <div
                            class="block font-mono text-xs italic lg:hidden md:block"
                          >
                            Rate Limit
                          </div>
                          {#if d.rateLimit}
                            {d.rateLimit}
                          {:else}
                            -
                          {/if}
                        </div>
                        <div class="w-24 p-2 text-sm">
                          <div
                            class="block font-mono text-xs italic lg:hidden md:block"
                          >
                            Expired
                          </div>
                          {#if d.onLogin}
                            {#if splitStrings(d.onLogin, 3)}
                              {splitStrings(d.onLogin, 3)}
                            {:else}
                              -
                            {/if}
                          {:else}
                            -
                          {/if}
                        </div>
                        <div class="w-40 p-2 text-sm">
                          <div
                            class="block font-mono text-xs italic lg:hidden md:block"
                          >
                            Mode
                          </div>
                          {#if d.onLogin}
                            {#if splitStrings(d.onLogin, 1)}
                              {splitStrings(d.onLogin, 1)}
                            {:else}
                              -
                            {/if}
                          {:else}
                            -
                          {/if}
                        </div>
                      </label>
                    </div>
                  {/each}
                {:else}
                  {#if filter}
                    <div class="flex items-center justify-center w-full h-full">
                      <div class="text-center">
                        <span class="italic text-gray-900 animate-pulse text-md"
                          >Data Not Found</span
                        >
                      </div>
                    </div>
                  {:else}
                    <div class="flex items-center justify-center w-full h-full">
                      <div class="text-center">
                        <span class="italic text-gray-900 animate-pulse text-md"
                          >Data Not Found</span
                        >
                      </div>
                    </div>
                  {/if}

                  <div class="flex items-center justify-center w-full h-full">
                    <div class="text-center">
                      <img
                        src="./assets/logo/logo_icon.svg"
                        alt="Mikhub Loading"
                        class="w-20 h-20 mx-auto animate-spin"
                        width="50"
                        height="50"
                      />
                    </div>
                  </div>
                {/if}
              </div>
            </div>
            <div
              class="flex flex-no-wrap items-center justify-center w-full my-5 rounded-lg"
            >
              <div
                class="flex items-center justify-center w-10 h-10 bg-white rounded-l-lg shadow"
                class:bg-gray-300={table.paging.currentPage === 0}
              >
                <button
                  class="w-full h-full focus:outline-none"
                  on:click={table.paging.onPrevious}>&laquo;</button
                >
              </div>
              {#each table.paging.buttons as btn (btn)}
                <div
                  class="flex items-center justify-center w-10 h-10 bg-white shadow"
                  class:bg-gray-300={btn.active}
                >
                  <button
                    class="w-full h-full focus:outline-none"
                    on:click={btn.onClick}>{btn.label}</button
                  >
                </div>
              {/each}
              <div
                class="flex items-center justify-center w-10 h-10 bg-white rounded-r-lg shadow"
                class:bg-gray-300={table.paging.currentPage >=
                  table.paging.pageCount - 1}
              >
                <button
                  class="w-full h-full focus:outline-none"
                  on:click={table.paging.onNext}>&raquo;</button
                >
              </div>
            </div>
          </MakeSortable>
        {:else}
          <div class="flex items-center justify-center w-full h-full">
            <div class="text-center">
              <img
                src="./assets/logo/logo_icon.svg"
                alt="Mikhub Loading"
                class="w-20 h-20 mx-auto animate-spin"
                width="50"
                height="50"
              />
              <span class="italic text-gray-900 animate-pulse text-md"
                >loading</span
              >
            </div>
          </div>
        {/if}
        <!--/TABLE SECTION-->
      </div>
    </div>
  </div>
</main>

{#if alert.length > 0}
  <div
    class="fixed bottom-0 left-0 right-0 z-50 w-full px-2 mb-10 lg:left-auto lg:w-3/12"
  >
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}
